// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"OurMission_gridContainer__giOqJ","vl":"OurMission_vl__2uckS"};